import { DateTime } from 'luxon';

import { FROM_ISO_OPTIONS } from '@shared/calendar/calendar_utils';

import { StorageCheckoutData } from '../data';

type AppointmentDateInput = Pick<
  StorageCheckoutData,
  'dateScheduled' | 'datePreferred'
>;

/**
 * Resolves the best available appointment DateTime from checkout values.
 * Prioritizes: dateScheduled > datePreferred > current time
 *
 * @param values - Checkout data (moving or storage), or a subset with dateScheduled/datePreferred
 * @returns DateTime representing the appointment time
 */
export const resolveAppointmentDateTime = (
  values: AppointmentDateInput,
): DateTime => {
  if (values.dateScheduled) {
    return DateTime.fromISO(values.dateScheduled.fromTime, FROM_ISO_OPTIONS);
  }

  return values.datePreferred || DateTime.local();
};
